require('./bootstrap');
require('select2/dist/js/select2.full');

const select2Language = {
    noResults: () => 'Nenhum produto encontrado',
    searching: () => 'Buscando…',
    inputTooShort: () => 'Digite para pesquisar',
    errorLoading: () => 'Não foi possível carregar os resultados',
};

window.initProductSelect = (context = document) => {
    window.$(context).find('select[data-product-select]').each(function () {
        const select = window.$(this);
        if (select.hasClass('select2-hidden-accessible')) return;

        select.select2({
            width: '100%',
            placeholder: select.data('placeholder') || 'Selecione um produto',
            allowClear: !select.prop('required'),
            minimumResultsForSearch: 0,
            language: select2Language,
        });
    });
};

window.destroyProductSelect = (select) => {
    const element = window.$(select);
    if (element.hasClass('select2-hidden-accessible')) element.select2('destroy');
};

window.loadZXing = () => import(/* webpackChunkName: "scanner" */ '@zxing/browser');
window.loadLabels = () => Promise.all([
    import(/* webpackChunkName: "labels" */ 'jsbarcode'),
    import(/* webpackChunkName: "labels" */ 'qrcode'),
]).then(([barcode, qrcode]) => ({JsBarcode: barcode.default, QRCode: qrcode.default}));

document.addEventListener('DOMContentLoaded', () => {
    window.initProductSelect(document);

    document.querySelectorAll('[data-confirm]').forEach((element) => {
        element.addEventListener('click', (event) => {
            if (!window.confirm(element.dataset.confirm)) event.preventDefault();
        });
    });

    document.querySelectorAll('[data-photo-input]').forEach((input) => {
        input.addEventListener('change', async () => {
            const file = input.files?.[0];
            const preview = document.querySelector(input.dataset.preview);
            const fileName = document.querySelector(input.dataset.fileName);
            if (!file) {
                if (fileName) fileName.textContent = 'Nenhuma foto selecionada';
                return;
            }
            if (fileName) fileName.textContent = 'Preparando foto…';
            try {
                const compressed = await compressImage(file);
                const transfer = new DataTransfer();
                transfer.items.add(compressed);
                input.files = transfer.files;
                if (fileName) fileName.textContent = compressed.name;
                if (preview) {
                    preview.src = URL.createObjectURL(compressed);
                    preview.classList.add('visible');
                }
            } catch {
                if (fileName) fileName.textContent = file.name;
                if (preview) {
                    preview.src = URL.createObjectURL(file);
                    preview.classList.add('visible');
                }
            }
        });
    });
});

async function compressImage(file) {
    if (!file.type.startsWith('image/')) return file;
    let source;
    let objectUrl;
    try {
        if (!window.createImageBitmap) throw new Error('createImageBitmap unavailable');
        source = await createImageBitmap(file);
    } catch {
        objectUrl = URL.createObjectURL(file);
        source = await new Promise((resolve, reject) => {
            const image = new Image();
            image.onload = () => resolve(image);
            image.onerror = reject;
            image.src = objectUrl;
        });
    }
    const max = 1600;
    const scale = Math.min(1, max / Math.max(source.width, source.height));
    const canvas = document.createElement('canvas');
    canvas.width = Math.round(source.width * scale);
    canvas.height = Math.round(source.height * scale);
    canvas.getContext('2d').drawImage(source, 0, 0, canvas.width, canvas.height);
    const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', .82));
    if (!blob) throw new Error('Image compression failed');
    source.close?.();
    if (objectUrl) URL.revokeObjectURL(objectUrl);
    return new File([blob], (file.name.replace(/\.[^.]+$/, '') || 'produto') + '.jpg', {type: 'image/jpeg'});
}
